import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { Plus } from 'lucide-react';
import './Car.css';

const url = process.env.REACT_APP_BACKEND_URL;

const Car = () => {
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const [districts, setDistricts] = useState([]);

  const [data, setData] = useState({
    tarkono: '',
    carname: '',
    ownername: '',
    ownerphone: '',
    drivername: '',
    driverphone: '',
    district: '',
  });

  // Fetch all districts on mount
  useEffect(() => {
    const fetchDistricts = async () => {
      try {
        const res = await axios.get(`${url}/api/district`);
        setDistricts(res.data.data || []);
      } catch (err) {
        toast.error('Failed to load districts');
      }
    };
    fetchDistricts();
  }, []);

  const onChangeHandler = (event) => {
    const { name, value } = event.target;
    setData((prevData) => ({ ...prevData, [name]: value }));
  };

  const onSubmitHandler = async (event) => {
    event.preventDefault();

    // Validate all fields
    for (const field in data) {
      if (!data[field]) {
        toast.error(`${field.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())} is required`);
        return;
      }
    }

    try {
      setSubmitting(true);
      const response = await axios.post(`${url}/api/car`, data);

      if (response.data.success) {
        toast.success('Car added successfully!');
        setData({
          tarkono: '',
          carname: '',
          ownername: '',
          ownerphone: '',
          drivername: '',
          driverphone: '',
          district: '',
        });
        navigate('/ViewCar');
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Failed to add car';
      toast.error(errorMessage);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="district-container">
      <div className="header">
        <h2>Add New Car</h2>
        <button onClick={() => navigate('/ViewCar')} className="add-button">
          <Plus size={16} /> View Cars
        </button>
      </div>

      <form className="district-form" onSubmit={onSubmitHandler}>
        <div className="form-group">
          <label>Tarkono</label>
          <input
            type="text"
            name="tarkono"
            value={data.tarkono}
            onChange={onChangeHandler}
            placeholder="Enter tarkono"
            required
          />
        </div>

        <div className="form-group">
          <label>Car Name</label>
          <input
            type="text"
            name="carname"
            value={data.carname}
            onChange={onChangeHandler}
            placeholder="Enter car name"
            required
          />
        </div>

        <div className="form-group">
          <label>Owner Name</label>
          <input
            type="text"
            name="ownername"
            value={data.ownername}
            onChange={onChangeHandler}
            placeholder="Enter owner name"
            required
          />
        </div>

        <div className="form-group">
          <label>Owner Phone</label>
          <input
            type="text"
            name="ownerphone"
            value={data.ownerphone}
            onChange={onChangeHandler}
            placeholder="Enter owner phone"
            required
          />
        </div>

        <div className="form-group">
          <label>Driver Name</label>
          <input
            type="text"
            name="drivername"
            value={data.drivername}
            onChange={onChangeHandler}
            placeholder="Enter driver name"
            required
          />
        </div>

        <div className="form-group">
          <label>Driver Phone</label>
          <input
            type="text"
            name="driverphone"
            value={data.driverphone}
            onChange={onChangeHandler}
            placeholder="Enter driver phone"
            required
          />
        </div>

        <div className="form-group">
          <label>District</label>
          <select
            name="district"
            value={data.district}
            onChange={onChangeHandler}
            required
          >
            <option value="">Select District</option>
            {districts.map((d) => (
              <option key={d._id} value={d._id}>
                {d.name}
              </option>
            ))}
          </select>
        </div>

        <div className="form-actions">
          <button type="submit" className="submit-button" disabled={submitting}>
            {submitting ? "Adding..." : "Add Car"}
          </button>
          <button
            type="button"
            onClick={() => navigate('/ViewCar')}
            className="cancel-button"
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default Car;